import React from 'react'
import { observer } from 'mobx-react-lite'

import TextField from '@mui/material/TextField'

import { ListItemAction, useGlobalCopyStore, useGoalStore } from '../../../common'
import { Goal } from '../../../core'
import { formatPercentage } from '../../../core/utils/NumberFormatting'

interface InterestRateActionProps {
  goal: Goal
}

export const InterestRateAction = observer(({ goal }: InterestRateActionProps) => {
  const { goals: copy } = useGlobalCopyStore()
  const { setAlert, setSelectedGoal, updateGoal } = useGoalStore()

  const [rate, setRate] = React.useState<number>(goal.interest_rate ?? 0)

  const isNew = !goal.guid
  const isInvalid = rate < 0

  const handleSave = async () => {
    const updatedGoal = { ...goal, interest_rate: rate }
    goal.interest_rate = rate

    if (isNew) {
      setSelectedGoal(updatedGoal)
    } else {
      await updateGoal(updatedGoal)
      setAlert(copy.alert_goal_updated_interest_rate)
    }
  }

  const handleCancel = () => {
    setTimeout(() => {
      setRate(goal.interest_rate ?? 0)
    }, 250)
  }

  return (
    <ListItemAction
      isDisabled={goal.is_complete}
      isSaveDisabled={isInvalid}
      label={`${copy.details_interest_rate} (%)`}
      onCancel={handleCancel}
      onSave={handleSave}
      primaryText={copy.details_interest_rate}
      secondaryText={formatPercentage(Number(goal.interest_rate) / 100) as string}
      zeroStateText={!goal.interest_rate ? copy.add_interest_rate : undefined}
    >
      <TextField
        error={isInvalid}
        fullWidth={true}
        onChange={(e) =>
          setRate(!isNaN(parseFloat(e.target.value)) ? parseFloat(e.target.value) : 0)
        }
        type="number"
        value={rate}
      />
    </ListItemAction>
  )
})
